import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { useBlackFridayCheckInProps } from '@base/activity/blackFridayCheckIn/useBlackFridayCheckIn';

type IProps = {
    checkIn: useBlackFridayCheckInProps
}

const LoadingButtons: React.FC<IProps> = (props) => {
    const { checkIn } = props
    const {
        currentStep,
        loading,
        onStartHandle,
    } = checkIn
    const timeCountRef = useRef<number>(5)
    const timeRef = useRef<any>('')

    const [timeCount, setTimeCount] = useState<number>(timeCountRef.current)

    const isNotStarted = ['not-started'].includes(currentStep);
    const isStartStage = ['start'].includes(currentStep);
    const isLoadingStage = ['loading'].includes(currentStep);

    const countdownHandle = () => {
        timeRef.current = setInterval(() => {
            timeCountRef.current = timeCountRef.current <= 1 ? 0 : timeCountRef.current - 1

            setTimeCount(timeCountRef.current)

            if (timeCountRef.current <= 0) {
                clearInterval(timeRef.current)
            }
        }, 1000)

    }

    useEffect(() => {
        if (currentStep === 'loading') {
            countdownHandle()
        }
    }, [currentStep])

    return (
        <div className={styles['btns-wrap']}>

            {(loading || isNotStarted) ? (
                <div className={styles['loading-wrap']}>
                    <div className={styles['loading-btn']}>
                        <div className={styles['loading']}>
                        </div>
                        <div className={styles['text-warp']}>
                            <div className={cn(styles['loading-text'])}>
                                {loading ? 'Loading' : ''}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {isStartStage && (
                        <div className={styles['btn-wrap']}>
                            <div className={cn('pointer', styles['start-btn'])}>
                                <div
                                    className={styles['btn-wrap']}
                                    onClick={() => onStartHandle()}
                                >
                                    <div className={styles['text']}>
                                        START
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {isLoadingStage && (
                        <div className={styles['loading-wrap']}>
                            <div className={styles['loading-btn']}>
                                <div className={styles['loading']}>
                                </div>
                                <div className={styles['text-warp']}>
                                    <div className={styles['text']}>
                                        {timeCount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

        </div>
    );
};

export default LoadingButtons